import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  Principales: any[] = [
    {
      id: 1,
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    }
  ]

  Listado: any[] = [
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    }
  ]

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    const pos = (document.documentElement.scrollTop || document.body.scrollTop) + 1200;
    const max = (document.documentElement.scrollHeight || document.body.scrollHeight);

    if (pos > max && this.Listado.length < 12) {
      this.Listado.push(
        {
          imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
          titulo: '¿Cómo hacer dropshipping?',
          parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
        },
        {
          imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
          titulo: '¿Cómo hacer dropshipping?',
          parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
        },
        {
          imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
          titulo: '¿Cómo hacer dropshipping?',
          parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
        },
        {
          imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
          titulo: '¿Cómo hacer dropshipping?',
          parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
        },
        {
          imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
          titulo: '¿Cómo hacer dropshipping?',
          parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
        },
        {
          imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
          titulo: '¿Cómo hacer dropshipping?',
          parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
        }
      );
      // console.log("llamada Scroll");
    }

    // console.log({ pos, max })

    let posY = document.getElementById("cajaSus").scrollHeight + 200;
    let posY2 = pos - 1400;
    let posFinalTemas = document.getElementById("temas").clientHeight;

    if (window.pageYOffset > posY) {
      let element = document.getElementById('cajaSus');
      element.classList.add('stickys');
    } else {
      let element = document.getElementById('cajaSus');
      element.classList.remove('stickys');
    }

    // console.log({ posY2, posFinalTemas })

    if (posY2 > posFinalTemas) {
      let element = document.getElementById('cajaSus');
      element.classList.add('sFinal');
    } else {
      let element = document.getElementById('cajaSus');
      element.classList.remove('sFinal');
    }

  }

  constructor() {

  }

  ngOnInit(): void {

  }

}
